// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"0173bb5a","952":"06cfea00"}[chunkId] + ".chunk.js";
};